/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios';
import get from 'lodash/get';
import {getApiUrl, storage} from '@app/utils/helpers';
import {ConfirmationModalPromise} from '@app/components';

const instance = axios.create({
  baseURL: getApiUrl(),
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(({notIncludeToken, ...config}) => {
  const token = storage.getItem('token', 'session');
  const headers = {...config.headers};

  if (token && !notIncludeToken) {
    headers.Authorization = `Bearer ${token}`;
  }

  return {...config, headers};
});

instance.interceptors.response.use(
  (res) => res.data || res,
  ({response}) => {
    const status = get(response, 'status');

    if (status === 401 || status === 403) {
      storage.removeItem('token', 'session');
      ConfirmationModalPromise({
        title: `Your login session expired. Do you want to login again?`,
        show: true,
        confirmBtn: 'Yes',
        cancelBtn: 'No',
        headTitle: 'Alert!',
      }).then(
        () => {
          window.location.href = '/login';
        },
        () => {
          //  do nothing on failure
        }
      );

      return null;
    }

    return Promise.reject({
      error: get(response, 'message', 'Bad request'),
      status,
      response: response.data,
    });
  }
);

export default instance;
